interface CalendarIconProps {
  size?: number;
  className?: string;
}

export function CalendarIcon({ size = 16, className }: CalendarIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33333 1.3328V3.99968M10.6667 1.3328V3.99968M2 6.66656H14M3.33333 2.66624H12.6667C13.403 2.66624 14 3.26324 14 3.99968V13.3338C14 14.0702 13.403 14.6672 12.6667 14.6672H3.33333C2.59695 14.6672 2 14.0702 2 13.3338V3.99968C2 3.26324 2.59695 2.66624 3.33333 2.66624Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
